import { useEffect, useState } from "react";
import { Loader } from "@/components/common/loader";
import { getMe, type SettingsUser } from "@/features/settings/api";
import { IdentityHero } from "@/features/settings/components/identity-hero";
import { ProfileForm } from "@/features/settings/components/profile-form";
import { SecurityForm } from "@/features/settings/components/security-form";

/** Profile settings (rendered by the `/profile` page) — identity hero, profile/
 * preferences + signature, and password. */
export function ProfileTab() {
  const [user, setUser] = useState<SettingsUser | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    getMe()
      .then((u) => active && setUser(u))
      .catch(() => active && setError(true));
    return () => {
      active = false;
    };
  }, []);

  if (error) {
    return (
      <p className="text-destructive text-sm">
        Couldn&apos;t load your settings. Please refresh and try again.
      </p>
    );
  }
  if (!user) {
    return (
      <div className="flex justify-center py-16">
        <Loader />
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-6">
      <IdentityHero user={user} onAvatarUploaded={setUser} />
      <ProfileForm user={user} onSaved={setUser} />
      <SecurityForm />
    </div>
  );
}

export default ProfileTab;
